import waves from './waves'
import wheel from './wheel'

export default {
  'waves': waves,
  'wheel': wheel
}



// WEBPACK FOOTER //
// ./src/translations/es/es.js